import { defineStore } from 'pinia'
import useAdmin from '../globalVariable'
const admin = useAdmin()

const LS_TOKEN_KEY_NAME = admin.LS_TOKEN_KEY_NAME
const LS_USER_KEY_NAME = admin.LS_USER_KEY_NAME
const LS_PERMISSION_KEY_NAME = admin.LS_PERMISSION_KEY_NAME

export const useAuthStore = defineStore('auth', {
  state: () => {
    const token = getDecodedValueFromLS(LS_TOKEN_KEY_NAME, 'string')
    const user_permissions = getDecodedValueFromLS(LS_PERMISSION_KEY_NAME, 'array')
    const user = getDecodedValueFromLS(LS_USER_KEY_NAME, 'object')

    // If token exists but userPermissions is missing, clear only auth-related keys
    if (token && (!user_permissions || user_permissions.length === 0)) {
      localStorage.removeItem(LS_TOKEN_KEY_NAME)
      localStorage.removeItem(LS_USER_KEY_NAME)
      localStorage.removeItem(LS_PERMISSION_KEY_NAME)
      return {
        status: '',
        token: '',
        user_permissions: [],
        user: {},
      }
    }

    return {
      status: '',
      token,
      user_permissions,
      user,
    }
  },
  actions: {
    setAccessToken(token: string, user: any, userPermission: Array<string>) {
      // Encrypt and store the token, user, and permissions
      this.setKeyEncodedValueInLS(LS_TOKEN_KEY_NAME, token)
      this.setKeyEncodedValueInLS(LS_USER_KEY_NAME, user)
      this.setKeyEncodedValueInLS(LS_PERMISSION_KEY_NAME, userPermission)

      // Update the state
      this.token = token
      this.user = user
      this.user_permissions = userPermission
    },
    clearAccessToken() {
      // Clear the token and user information from the state and localStorage
      // this.token = null;
      this.user = {}
      this.user_permissions = []

      localStorage.removeItem(LS_TOKEN_KEY_NAME)
      localStorage.removeItem(LS_USER_KEY_NAME)
      localStorage.removeItem(LS_PERMISSION_KEY_NAME)
    },
    setKeyEncodedValueInLS(lsKey: string, value: any) {
      // Convert value to string if necessary, then encrypt and store in localStorage
      // const stringValue = typeof value === 'string' ? value : JSON.stringify(value)
      // const ciphertext = CryptoJS.AES.encrypt(stringValue, admin.SECRET_KEY).toString()
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value)
      localStorage.setItem(lsKey, stringValue) // Store as JSON string
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token && state.user_permissions && state.user_permissions.length > 0, // Check if the user is logged in and has permissions
    authStatus: (state) => state.status, // Return authentication status
    authUser: (state) => state.user, // Return the authenticated user
    bearerToken: (state) => state.token, // Return the bearer token
    getAllPermission: (state) => state.user_permissions, // Return all user permissions
    // hasPermission: (state) => (permission_name) => {
    //   // Check if the user has the required permission(s)
    //   if (typeof permission_name === 'object') {
    //     return permission_name.some((item) => state.user_permissions.includes(item))
    //   }
    //   return state.user_permissions.includes(permission_name);
    // },
  },
})

// Utility function to decode and retrieve data from localStorage
export const getDecodedValueFromLS = (lsKey: string, dataType: string) => {
  // const ciphertext = localStorage.getItem(lsKey)
  // if (ciphertext) {
  //   // Decrypt the stored data
  //   const bytes = CryptoJS.AES.decrypt(ciphertext, admin.SECRET_KEY);
  //   const decryptedStringData = bytes.toString(CryptoJS.enc.Utf8);
  //   if (dataType === 'string') {
  //     return decryptedStringData;
  //   }
  //   return JSON.parse(decryptedStringData);
  // }
  const storedValue = localStorage.getItem(lsKey)

  if (storedValue) {
    try {
      if (dataType === 'string') {
        return storedValue
      } else if (dataType === 'array') {
        // Handle both JSON array format and comma-separated string format
        if (storedValue.startsWith('[') && storedValue.endsWith(']')) {
          return JSON.parse(storedValue)
        } else {
          // Handle comma-separated string format
          return storedValue
            .split(',')
            .map((permission) => permission.trim())
            .filter(Boolean)
        }
      } else if (dataType === 'object') {
        return JSON.parse(storedValue)
      }
    } catch (e) {
      console.error(`Error parsing stored value for ${lsKey}:`, e)
    }
  }

  // Return default values if localStorage item doesn't exist
  if (dataType === 'string') {
    return ''
  } else if (dataType === 'array') {
    return []
  } else if (dataType === 'object') {
    return {}
  }
}
export const logout = (router: any) => {
  const authStore = useAuthStore()
  authStore.clearAccessToken()
  router.push({ name: 'login' })
}
export const clearLocalStore = () => {
  const authStore = useAuthStore()
  authStore.clearAccessToken()
  // clearLocalStore already clears auth-related keys via clearAccessToken()
}
